module.exports = __webpack_public_path__ + "img/wallet2.29b36d87.svg";